import { Component, HostListener, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Constants } from '../../common/constants';
import { Title, Meta } from '@angular/platform-browser';
import * as AOS from 'aos';
import { Router } from '@angular/router';
import { TeamService } from '../../shared/services/team.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';


@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.css']
})
export class TeamComponent implements OnInit {
  isMobile: boolean = false;
  teamMembers!: any[];
  isBrowser: boolean = false;


  constructor(private teamService: TeamService, 
    private titleService: Title, private router: Router, 
    @Inject(PLATFORM_ID) private platformId: any, private _renderer2: Renderer2,
      @Inject(DOCUMENT) private _document: Document,
    private seoService: SeoService,
    private metaService: Meta) {
      this.isBrowser = isPlatformBrowser(this.platformId);
    if (this.isBrowser) {
      this.isMobile = window.innerWidth <= 768;
    }
  }
  ngOnInit(): void {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": ""
  },
  "headline": "Meet Our Team | Expertise and Dedication at Maganti IT",
  "description": "The strength of the team is each individual member. The strength of each member is the team.",
  "image": "https://mitresource.com/assets/images/team/teamBanner.png",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-10-24"
} `;
   
    this._renderer2.appendChild(this._document.head, script);
    // this.seoService.createLinkForCanonicalURL();
    this.setTitleAndMetaTags();

    if (this.isBrowser) { AOS.init({ disable: 'mobile', duration: 2000, delay: 500 }); }
   
    // Fetch team data from the service
    this.teamService.getTeamMembers().subscribe(data => {
      this.teamMembers = data;

    });

  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (this.isBrowser) {
      this.isMobile = event.target.innerWidth <= 768;
    }
  }
  baseUrl = Constants.baseUrl;


  onEmpIdClick(empId: string) {
    // console.log('Employee ID clicked:', empId);
    // Navigate to the profile page with the employee ID
    this.router.navigate(['/profile', empId]);
  }

  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Meet Our Team | Expertise and Dedication at Maganti IT');

    this.metaService.addTags([
      { name: 'description', content: 'The strength of the team is each individual member. The strength of each member is the team.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Meet Our Team | Expertise and Dedication at Maganti IT' },
      // { property: 'og:url', content: 'https://mitresource.com/teams/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/team/leader/vani.jpg' },
      { property: 'og:description', content: 'The strength of the team is each individual member. The strength of each member is the team.' },
    ]);
  }
}
